<template>
  <div class="page">
    <div class="hd">
      <router-link to="/" class="backup">
        <span class="iconfont iconpre"> </span>返回列表
      </router-link>
      <span class="title-mag">搜索</span>
    </div>
    <slot></slot>
    <slot name="ft"></slot>
  </div>
</template>
<script>
export default {
  methods: {
    goback() {
      this.$router.go(-1);
    },
  },
};
</script>
